export default function AboutUsSolutions(){
    return(
        <>
        <section className="about-us" id="about-us">
            <div className="container aos-init aos-animate" data-aos="fade-up">
                <div className="section-title aos-init aos-animate" data-aos="fade-in" data-aos-delay="100">
                    <h2>About Us</h2>
                    <p className="mb-0"> Golden Exports was established in 2007 to make a robust mark on the
                        international trade landscape. Headquartered in Ningbo, Zhenjiang, China, we have offices
                        located in strategic locations like Dubai, India, Hong Kong, and Suzhou.
                        With a team size of over 70 employees, we are committed to providing exceptional services to
                        our customers spread across Europe, North America & Africa.
                    </p>
                </div>
            </div>
        </section>
        </>
    );
}